import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LegalAndNewsletterCheckboxForm } from '../legal-and-newsletter-checkbox/legal-and-newsletter-checkbox.component';
import { UserApiService } from '../../../../api';
import { getUser } from '../../../../store/user/user.actions';
import { Store } from '@ngrx/store';

export type AcceptTermsDialogComponentData = {
    userId: string;
    tosAccepted: Date | null;
    lastUpdated: Date;
    newsLetter: boolean | null;
};

@Component({
    selector: 'app-accept-terms-dialog',
    templateUrl: './accept-terms-dialog.component.html',
    styleUrls: ['./accept-terms-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AcceptTermsDialogComponent {
    protected termsForms: Partial<LegalAndNewsletterCheckboxForm> = {};

    constructor(
        private readonly dialogRef: MatDialogRef<AcceptTermsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: AcceptTermsDialogComponentData,
        private userService: UserApiService,
        private store: Store
    ) {}

    save() {
        if (this.termsForms.valid) {
            this.userService
                .acceptTermsOfService({
                    body: {
                        privacy: this.termsForms.privacyPolicy ?? false,
                        tos: this.termsForms.generalTerms ?? false,
                        newsletter: this.termsForms.newsLetter ?? false
                    }
                })
                .subscribe(() => {
                    this.store.dispatch(getUser({ automaticLogin: true }));
                    this.dialogRef.close(true);
                });
        }
    }

    protected readonly termsFormsChange = (change: Partial<LegalAndNewsletterCheckboxForm>) => {
        this.termsForms = change;
    };
}
